var React = require('react');

function De (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#ffce00","d":"M0 320h640v160H0z","key":0}),React.createElement("path",{"d":"M0 0h640v160H0z","key":1}),React.createElement("path",{"fill":"#d00","d":"M0 160h640v160H0z","key":2})]);
}

De.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = De;

De.default = De;
